"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var nameSearch_exports = {};
__export(nameSearch_exports, {
  getNameSearch: () => getNameSearch,
  getNameSearchTokens: () => getNameSearchTokens,
  getPlainSearch: () => getPlainSearch
});
module.exports = __toCommonJS(nameSearch_exports);
function getPlainSearch(search) {
  return { like: "%" + search + "%", matches: /* @__PURE__ */ __name(() => true, "matches") };
}
__name(getPlainSearch, "getPlainSearch");
function getNameSearchTokens(search) {
  return search.split(/[\s,]+/).filter((it) => it.length > 0);
}
__name(getNameSearchTokens, "getNameSearchTokens");
function getNameSearch(search) {
  const tokens = getNameSearchTokens(search);
  if (tokens.length < 2) {
    return getPlainSearch(search);
  }
  const longest = tokens.reduce((a, b) => b.length > a.length ? b : a);
  const lower = tokens.map((it) => it.toLowerCase());
  return {
    like: "%" + longest + "%",
    matches: /* @__PURE__ */ __name((value) => {
      if (value == null) return false;
      const str = String(value).toLowerCase();
      return lower.every((it) => str.includes(it));
    }, "matches")
  };
}
__name(getNameSearch, "getNameSearch");
//# sourceMappingURL=nameSearch.js.map
